(function() {
  if (!window.location.pathname.includes('/policies/shipping-policy')) return;

  var countries = [
    {
      key: 'de',
      label: 'Deutschland',
      flag: '🇩🇪',
      heading: 'Lieferung nach Deutschland',
      lead: 'Versandkostenfrei ab einem Bestellwert von 75 €.',
      details: [
        'Bei Bestellungen unter 75 € fallen 5,95 € Versandgebühren an.',
        'Die Lieferung erfolgt in der Regel innerhalb von 3-4 Werktagen.'
      ]
    },
    {
      key: 'at',
      label: 'Österreich',
      flag: '🇦🇹',
      heading: 'Lieferung nach Österreich',
      lead: 'Für Lieferungen nach Österreich berechnen wir 6,95 €.',
      details: [
        'Einen kostenlosen Versand ab einem bestimmten Warenkorbwert bieten wir bei Sendungen nach Österreich aktuell nicht an.',
        'Die Lieferung erfolgt in der Regel innerhalb von 5-7 Werktagen.'
      ]
    },
    {
      key: 'ch',
      label: 'Schweiz',
      flag: '🇨🇭',
      heading: 'Lieferung in die Schweiz',
      lead: 'Für Lieferungen in die Schweiz berechnen wir 15 CHF.',
      details: [
        'Bei Empfang der Lieferung können zusätzlich Zölle und Mehrwertsteuer anfallen.',
        'Einen kostenlosen Versand ab einem bestimmten Warenkorbwert bieten wir bei Sendungen in die Schweiz aktuell nicht an.',
        'Die Lieferung erfolgt in der Regel innerhalb von 5-7 Werktagen.'
      ]
    }
  ];

  var extraSections = [
    {
      title: 'Lieferfristen',
      content: [
        'Soweit im jeweiligen Angebot keine andere Frist angegeben ist, erfolgt die Lieferung innerhalb der im ausgewählten Land genannten Lieferzeit nach Vertragsschluss.',
        'Bei vereinbarter Vorauszahlung beginnt die Lieferfrist nach dem Zeitpunkt Deiner Zahlungsanweisung.'
      ]
    },
    {
      title: 'Wichtige Hinweise zur Zustellung',
      content: [
        'Bitte beachte, dass an Sonn- und Feiertagen keine Zustellung erfolgt.',
        'Hast Du Artikel mit unterschiedlichen Lieferzeiten bestellt, versenden wir die Ware in einer gemeinsamen Sendung, sofern keine abweichenden Vereinbarungen getroffen wurden. Die Lieferzeit richtet sich dann nach dem Artikel mit der längsten Lieferzeit.'
      ]
    },
    {
      title: 'Sendungsverfolgung',
      content: [
        'Sobald Deine Sendung auf dem Weg ist, erhältst Du eine Versandbestätigung per E-Mail. Wenn eine Sendungsverfolgung verfügbar ist, findest Du den Tracking-Link direkt in dieser E-Mail.'
      ]
    }
  ];

  function iconMarkup() {
    return '<span class="details__icon"><svg style="width:60px;height:60px;" width="60" height="60" viewBox="0 0 436 436" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><circle cx="217.808" cy="217.808" r="143.513" transform="rotate(-45 217.808 217.808)" stroke="#D3DBBB" stroke-width="21.0019"/><rect x="205.664" y="140.801" width="28.0025" height="154.014" rx="14.0012" fill="#D3DBBB"/><rect x="296.68" y="203.807" width="28.0025" height="154.014" rx="14.0012" transform="rotate(90 296.68 203.807)" fill="#D3DBBB"/></svg></span>';
  }

  function buildCountryPanel(country) {
    return [
      '<section class="shipping-policy__country-panel" data-shipping-country-panel="' + country.key + '" hidden>',
      '<h2>' + country.flag + ' ' + country.heading + '</h2>',
      '<p><strong>' + country.lead + '</strong></p>',
      '<ul>',
      country.details.map(function(item) {
        return '<li>' + item + '</li>';
      }).join(''),
      '</ul>',
      '</section>'
    ].join('');
  }

  function buildDetail(section, index) {
    return [
      '<details class="details is-faq shipping-policy__detail" name="shipping-policy-details" ' + (index === 0 ? 'open' : '') + '>',
      '<summary><h3 class="details__title">' + section.title + '</h3>' + iconMarkup() + '</summary>',
      '<div class="details__content">',
      section.content.map(function(item) {
        return '<p>' + item + '</p>';
      }).join(''),
      '</div></details>'
    ].join('');
  }

  function init() {
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;

    document.body.classList.add('shipping-policy-page');
    if (body.dataset.shippingPolicyEnhanced === 'true') return;
    body.dataset.shippingPolicyEnhanced = 'true';
    body.innerHTML = [
      '<div class="shipping-policy__countries" role="tablist" aria-label="Lieferland auswählen">',
      countries.map(function(country, index) {
        return '<button type="button" class="shipping-policy__country-button new-button' + (index === 0 ? '' : ' is-outline') + '" data-shipping-country="' + country.key + '" aria-selected="' + (index === 0 ? 'true' : 'false') + '">' + country.flag + ' ' + country.label + '</button>';
      }).join(''),
      '</div>',
      '<div class="shipping-policy__country-panels">',
      countries.map(buildCountryPanel).join(''),
      '</div>',
      '<div class="shipping-policy__details">',
      extraSections.map(buildDetail).join(''),
      '</div>'
    ].join('');

    var buttons = Array.prototype.slice.call(body.querySelectorAll('[data-shipping-country]'));
    var panels = Array.prototype.slice.call(body.querySelectorAll('[data-shipping-country-panel]'));

    function selectCountry(key) {
      buttons.forEach(function(button) {
        var selected = button.dataset.shippingCountry === key;
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.classList.toggle('is-outline', !selected);
      });

      panels.forEach(function(panel) {
        panel.hidden = panel.dataset.shippingCountryPanel !== key;
      });
    }

    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        selectCountry(button.dataset.shippingCountry);
      });
    });

    body.querySelectorAll('.shipping-policy__detail').forEach(function(detail) {
      detail.addEventListener('toggle', function() {
        if (!detail.open) return;

        body.querySelectorAll('.shipping-policy__detail').forEach(function(otherDetail) {
          if (otherDetail !== detail) otherDetail.open = false;
        });
      });
    });

    selectCountry(countries[0].key);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
